import { ButtonSize, ButtonVariant } from "@galaxy-io/dls/buttons/Button";
import { InputSize } from "@galaxy-io/dls/inputs/Input";
import { XIcon } from "@phosphor-icons/react";
import { startTransition, useOptimistic } from "react";
import { useRouter } from "@/app/navigation";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SearchForm } from "@/components/workspace/people-styles";
import { Toolbar } from "@/components/workspace/toolbar";
import { PEOPLE_FILTER_KEYS } from "@/lib/filters";
import { DirectoryFilterBuilder } from "./directory-filter-builder";

export function PeopleFilters({ query }: { query: Record<string, string | undefined> }) {
  const router = useRouter();
  const [filters, updateFilters] = useOptimistic(
    query,
    (current, values: Record<string, string>) => ({ ...current, ...values }),
  );
  function apply(values: Record<string, string>) {
    const next = new URLSearchParams(
      Object.entries(filters).filter((entry): entry is [string, string] => entry[1] !== undefined),
    );
    next.delete("page");

    next.delete("personId");
    for (const [key, value] of Object.entries(values)) {
      if (value) next.set(key, value);
      else next.delete(key);
    }
    startTransition(() => {
      updateFilters(values);
      router.push(`/people?${next}`);
    });
  }
  const active = PEOPLE_FILTER_KEYS.some((key) => filters[key]);
  return (
    <Toolbar>
      <SearchForm
        onSubmit={(event) => {
          event.preventDefault();
          apply({
            q: String(new FormData(event.currentTarget).get("q") || ""),
          });
        }}
      >
        <Input
          key={query.q || ""}
          name="q"
          aria-label="Search people"
          placeholder="Search people, companies, tags…"
          defaultValue={query.q || ""}
          type="search"
          size={InputSize.SMALL}
          label="Search people"
          hideLabel
        />
      </SearchForm>
      <DirectoryFilterBuilder kind="person" query={filters} onApply={apply} />
      {active && (
        <Button
          label="Clear"
          ariaLabel="Clear people filters"
          icon={XIcon}
          variant={ButtonVariant.TERTIARY}
          onClick={() => apply(Object.fromEntries(PEOPLE_FILTER_KEYS.map((key) => [key, ""])))}
          size={ButtonSize.SMALL}
          tooltip="Clear people filters"
        />
      )}
    </Toolbar>
  );
}
